import { jsx } from "react/jsx-runtime";
function highlightMatches(text, matches) {
  const sortedMatches = [...matches].sort((a, b) => a.offset - b.offset), elements = [];
  let currentIndex = 0;
  return sortedMatches.forEach(({ offset, length }, index) => {
    offset > currentIndex && elements.push(text.slice(currentIndex, offset)), elements.push(
      /* @__PURE__ */ jsx("strong", { children: text.slice(offset, offset + length) }, index)
    ), currentIndex = offset + length;
  }), currentIndex < text.length && elements.push(text.slice(currentIndex)), /* @__PURE__ */ jsx("span", { children: elements });
}
export {
  highlightMatches
};
//# sourceMappingURL=highlightMatches.js.map
